import { createFileRoute } from '@tanstack/react-router';

import { BgRemovalView } from 'src/sections/admin/bg-removal/bg-removal-view';

export const Route = createFileRoute('/admin-skidog/bg-removal')({
  component: BgRemovalView,
});
